
const validationPhoneNumber = (str) => {
  if(!str) return false
  str = str.split("-").join("")
  str = str.split(" ").join("")
  str = str.split("\r").join("")
  str = str.split("\n").join("")
  var re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s.0-9]*$/;
  return re.test(str)&&str.length === 10;
};
export default validationPhoneNumber;
